import { computed, ref } from 'vue'

import { buildUrlParameters, pushUrlParameters, getTableData } from '../Methods/utils'

import NewCarLoanCalculatorSummary from '../Components/NewCarLoanCalculatorSummary/NewCarLoanCalculatorSummary.vue'
import CalculatorInfoBox from 'components/CalculatorInfoBox/CalculatorInfoBox.vue'
import NewCarLoanCalculatorAdjustLoan from '../Components/NewCarLoanCalculatorAdjustLoan/NewCarLoanCalculatorAdjustLoan.vue'
import CalculatorTable from 'components/CalculatorTable/CalculatorTable.vue'

export default {
    name: 'NewCarLoanCalculatorResult',
    components: {
        NewCarLoanCalculatorAdjustLoan,
        NewCarLoanCalculatorSummary,
        CalculatorTable,
        CalculatorInfoBox
    },
    props: {
        blockId: {
            type: Number,
            required: true,
        },
        apiUrl: {
            type: String,
            required: true,
        },
        labelsInfo: {
            type: Object,
            required: true,
        },
        labelsSummary: {
            type: Object,
            required: true,
        },
        labelsLegal: {
            type: Object,
            required: true,
        },
        labelsInput: {
            type: Object,
            required: true,
        },
        labelsError: {
            type: Object,
            required: true,
        },
        labelsTable: {
            type: Object,
            required: true,
        },
        optionsInput: {
            type: Object,
            required: true,
        },
        links: {
            type: Array,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const isAdjustLoanOpen = ref(false)
        const infoBoxData = { title: props.labelsInfo.title, description: props.labelsInfo.description }
        const infoBoxStyles = { color: "gamma" }
        const data = ref(props.data)
        const tables = computed(() => getTableData(data.value.tables || []))

        const throwError = () => {
            const errorUrlParameters = {
                "isError": data.value.isError
            };
            pushUrlParameters(errorUrlParameters)
        }

        if (data.value.isError) {
            throwError();
        }

        const adjustLoanButtonCallback = () => {
            isAdjustLoanOpen.value = !isAdjustLoanOpen.value
        }

        const onAdjustCallback = (res) => {
            const mappedUrlParameters = {
                id: props.blockId,
                carPrice: res.carPrice,
                downPayment: res.downPayment,
                loanTerm: res.loanTerm
            };
            const params = buildUrlParameters(mappedUrlParameters)
            const apiBase = window.location.origin;
            const url = `${apiBase}/${props.apiUrl + params}`

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throwError()
                    }
                    return response.json()
                })
                .then(result => {
                    if (result.isError) {
                        throwError()
                    }

                    data.value = result
                })
                .catch(error => {
                    throwError()
                })
        };

        return {
            data,
            tables,
            infoBoxData,
            infoBoxStyles,
            isAdjustLoanOpen,
            adjustLoanButtonCallback,
            onAdjustCallback
        }
    },
}